// Libs
import React from 'react';
import { Modal, Form } from 'react-bootstrap';
import moment from 'moment';

// Services & Helpers
import TextHelpers from 'helpers/TextHelpers';

// Components
import Loader from 'components/common/Loader';
import AvailabilityModal from 'components/admin/AvailabilityModal';
import BookingNotesModal from 'components/instructor/BookingNotesModal';

//-------------------------------------------------------------------------------------------------------------------

class InstructorListModal extends React.Component {

    constructor(props) {
        super(props);

        this.bookingNotesModalRef = React.createRef();

        this.state = {
            instructor: null
        };
    }

    show(opts) {
        return new Promise((resolve, reject) => {
            this.opts = opts;
            this.resolve = resolve;
            const dates = opts.dates.map(d => new Date(d));
            this.setState({
                isOpen: true,
                instructors: opts.instructors,
                dates: opts.dates,
                isRamping: opts.isRamping,
                startDate: new Date(Math.min.apply(0, dates)),
                endDate: new Date(Math.max.apply(0, dates)),
                showNumDeliveries: opts.showNumDeliveries,
                showDailySellRate: opts.type == 'VendorClassSearch' || opts.showDailySellRate,
                type: opts.type
            });
        });
    }

    close() {
        this.setState({
            isOpen: false
        });
    }

    render() {
        const {
            isOpen,
            instructor,
            dates,
            startDate,
            endDate
        } = this.state;

        if (!isOpen) {
            return null;
        }

        return (<>
            <Modal show className="instructor-list-modal">
                {this.renderInner()}
            </Modal>

            {instructor &&
                <AvailabilityModal
                    instructor={instructor}
                    startDate={startDate}
                    endDate={endDate}
                    highlightDates={dates}
                    onClose={() => this.setState({ instructor: null })}
                />
            }

            <BookingNotesModal ref={this.bookingNotesModalRef} />

        </>);
    }

    renderInner() {
        const {
            isLoading,
            instructors,
            dates,
            isRamping,
            showDailySellRate,
            type
        } = this.state;

        if (isLoading) {
            return (
                <Modal.Body>
                    <Loader />
                </Modal.Body>
            );
        }

        return (<>
            <div className="modal-header">
                {type != 'VendorClassSearch' &&
                    <Form.Check
                        type="checkbox"
                        id="show-margin-modal"
                        checked={!showDailySellRate}
                        onChange={e => this.setState({ showDailySellRate: !e.target.checked })}
                        label="Show margin"
                    />
                }

                <button type="button" className="btn btn-secondary ms-auto ms-auto" onClick={() => this.close()}>
                    Close
                </button>
            </div>
            <Modal.Body>

                <div className="sticky-table-container scrolling no-max-height-desktop">
                    <table className="table sticky-table table-bordered">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Location</th>
                                <th>Instructor Status</th>
                                <th>{showDailySellRate ? 'Daily Rate' : 'Daily Margin'}</th>
                                {/*{dates.length > 0 &&
                                    <th>Profit</th>
                                }*/}
                                {isRamping ?
                                    <th>Est. Completion</th> :
                                    <th><abbr title="Number of times the instructor has delivered this course previously">No. of Deliveries</abbr></th>
                                }
                                <th><abbr title="Average CSAT score for this instructor & course (YTD average CSAT score for this instructor, all courses)">CSAT Average</abbr></th>
                                {/*<th><abbr title="Number of courses this instructor is approved to deliver">Appr.</abbr></th>*/}
                                {dates.length > 0 &&
                                    <th>Availability</th>
                                }
                                {type != 'VendorClassSearch' &&
                                    <th>Warning</th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {instructors.map(instructor => {
                                let warnings = [];
                                for (let i = 0; i < instructor.certs.length; i++) {
                                    const ic = instructor.certs[i];
                                    warnings.push(`${ic.certName} expires on ${moment(ic.expiryDate).format('DD/MM/YYYY')}`);
                                }
                                if (instructor.bookingNotes) {
                                    warnings.push(instructor.bookingNotes);
                                }
                                const marginOrRate = (showDailySellRate ? instructor.sellRate : instructor.margin);
                                return (
                                    <tr key={instructor.id}>
                                        <td>
                                            <a
                                                className="btn btn-secondary btn-sm fa-solid fa-search"
                                                href={`/instructor/${instructor.slug}`}
                                                target="_blank"
                                            ></a>{' '}
                                            {TextHelpers.formatInstructorName(instructor)}
                                        </td>
                                        <td>
                                            {instructor.email &&
                                                <a href={`mailto:${instructor.email}`}>{instructor.email}</a>
                                            }
                                        </td>
                                        <td>
                                            {instructor.country ? instructor.country.name : null}
                                            {instructor.country && instructor.city && <><br /></>}
                                            {instructor.city ? instructor.city.name : null}
                                        </td>
                                        <td>{instructor.status}</td>
                                        <td>
                                            {marginOrRate > 0 ? TextHelpers.formatCurrencyNew(marginOrRate) : ''}
                                        </td>
                                        {/*{dates.length > 0 &&
                                        <td>{TextHelpers.formatCurrencyNew(instructor.margin * dates.length)}</td>
                                    }*/}
                                        {isRamping ?
                                            <td>{instructor.estimatedCompletionDate ? moment(instructor.estimatedCompletionDate).format('DD/MM/YYYY') : null}</td> :
                                            <td>{instructor.numDeliveries}</td>
                                        }
                                        <td>
                                            {instructor.averageCSAT ? Math.round(instructor.averageCSAT * 100) / 100 : null}
                                            {instructor.averageCSATAllCourses ? ' (' + (Math.round(instructor.averageCSATAllCourses * 100) / 100) + ')' : null}
                                        </td>
                                        {/*<td>{instructor.numApprovedCourses}</td>*/}
                                        {dates.length > 0 &&
                                            <td>
                                                {instructor.numAvailableDates} / {dates.length}
                                                {' '}
                                                ({Math.round(instructor.numAvailableDates / dates.length * 100)}%)
                                                {' '}
                                                <button
                                                    className="btn btn-secondary btn-sm fa-solid fa-search float-end"
                                                    onClick={() => this.setState({ instructor })}
                                                />
                                            </td>
                                        }
                                        {type != 'VendorClassSearch' &&
                                            <td>
                                                {warnings.length > 0 &&
                                                    <button className="btn btn-sm btn-danger" title={warnings.join('\r\n\r\n')}>
                                                        <span className="fa fa-triangle-exclamation" />
                                                    </button>
                                                }
                                            </td>
                                        }
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-secondary ms-auto ms-auto" onClick={() => this.close()}>
                    Close
                </button>
            </Modal.Footer>
        </>);
    }

}

export default InstructorListModal;